module.exports = __webpack_public_path__ + "static/media/microsoft-logo.5162c10b.svg";